<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base overflow-hidden">
                      <vx-tooltip :text="$t('Labels.Edit')" class="float-right" color="primary" >
                        <vs-button  @click="edit()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-edit" icon-pack="feather" type="filled"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip :text="$t('Labels.Activate')" class="float-right" color="primary" >
                        <vs-button  @click="requestPassword('doActivate')" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-check-circle" icon-pack="feather" type="filled"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip :text="$t('Labels.Delete')" class="float-right" color="primary" >
                        <vs-button  @click="requestPassword('doDelete')" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-trash" icon-pack="feather" type="filled"></vs-button>
                      </vx-tooltip>
                      <h4>{{$t('Labels.Detail')}}</h4>
                      <table cellspancing="5" class="border-separate mt-5">
                        <tbody>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.DevEui')}}</td>
                            <td class=" px-2 py-1">{{response.deveui}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Serie')}}</td>
                            <td class=" px-2 py-1">{{response.serie}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.DevAddress')}}</td>
                            <td class=" px-2 py-1">{{response.dev_address}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.DeviceType')}}</td>
                            <td class=" px-2 py-1">{{response.device_type.name}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.AppKey')}}</td>
                            <td class=" px-2 py-1"><vs-button radius color="primary" type="flat" icon="visibility" class="float-left"></vs-button></td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.NetworkKey')}}</td>
                            <td class=" px-2 py-1"><vs-button radius color="primary" type="flat" icon="visibility" class="float-left"></vs-button></td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.CreatedAt')}}</td>
                            <td class=" px-2 py-1">{{response.created_at}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
                            <td class=" px-2 py-1">{{response.user_creator.first_name + ' ' + response.user_creator.last_name}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.UpdatedAt')}}</td>
                            <td class=" px-2 py-1">{{response.updated_at}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Modifier')}}</td>
                            <td class=" px-2 py-1">{{response.user_update != null ? response.user_update.first_name + ' ' + response.user_update.last_name:''}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.LastSeen')}}</td>
                            <td class=" px-2 py-1">{{response.last_seen_at}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </vx-card>
                </div>
                
            </div>
            <div class="w-full">
              <vx-card class="grid-view-item mb-base overflow-hidden">
                  <h4>{{$t('Labels.Assignments')}}</h4>
                <table cellspancing="5" class="border-separate mt-5" v-if="response">
                  <tbody>
                    <tr>
                      <td class="bg-grey-light px-4 py-1 rounded ">{{$tc('Labels.App',1)}}</td>
                      <td class=" px-2 py-1">{{response.application}}</td>
                      <vs-button @click="goApp()" type="border">{{$t("Labels.GoTo") + ' ' + $tc("Labels.App",1)}}</vs-button>
                    </tr>
                    <tr>
                      <td class="bg-grey-light px-4 py-1 rounded ">{{$tc('Labels.License',1)}}</td>
                      <td class=" px-2 py-1">{{response.license_uuid}}</td>
                      <vs-button v-if="response.license_uuid != null" @click="goLicense()" type="flat">{{$t("Labels.GoTo") + ' ' + $tc("Labels.License",1)}}</vs-button>
                      <vs-button v-else @click="goAssign()" type="border">{{$t("Labels.GoTo") + ' ' + $t("Labels.Assign")}}</vs-button>
                    </tr>
                  </tbody>
                </table>
              </vx-card>
            </div>
            <div class="w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden address-card">
                    <div style="width: 100%">
                        <select class="vs-vs-inputx vs-input--input mb-3" v-model="logLimit" style="float: right; width: 90px;" @change="getResponse()">
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    <h4>{{$t('ChangeHistory')}}</h4>
                    <vs-table v-if="logData" :data="logData">
                      <template slot="thead">
                        <vs-th sort-key="updated_at">
                          {{$t('Labels.UpdatedAt')}}
                        </vs-th>
                        <vs-th sort-key="serie">
                          {{$t('Labels.Serie')}}
                        </vs-th>
                        <vs-th sort-key="user">
                          {{$t('Labels.Modifier')}}
                        </vs-th>
                      </template>

                      <template  slot-scope="{data}">
                        <vs-tr :data="item" :key="index" v-for="(item, index) in data" >
                          <vs-td :data="item.updated_at">
                            {{item.updated_at}}
                          </vs-td>
                          <vs-td :data="item.serie">
                            {{item.serie}}
                          </vs-td>
                          <vs-td :data="item.user">
                            {{item.user != null ? item.user.first_name + ' ' + item.user.last_name:''}}
                          </vs-td>
                          
                        </vs-tr>
                      </template>
                    </vs-table> 
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
import valueItem from '@/components/valueItem/valueItem.vue'
import listItem from '@/components/listItem/listItem.vue'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    valueItem,
    listItem
  },

  data () {
    return {
      response: [],
      uuid: this.$route.params.uuid,
      logLimit: 5,
      logData: [],
      callDoDelete: false,
      callActivate: false
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `devices/${this.uuid}`,
        method: 'GET',
        params: {
          limit: this.logLimit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        if (this.response.device_records != null) this.logData = this.response.device_records
      })
    },
    goApp () {
      window.location.href =  `/apps/${uuid}`
    },
    goLicense () {
      window.location.href =  `/licenses/${this.response.license_uuid}`
    },
    edit (uuid) {
      window.location.href =  `/devices/${this.uuid}/update`
    },
    async activate () {
      const params = {
        url: `devices/activate_device/${this.response.deveui}`,
        method: 'DELETE',
        params: {}
      }
      await request(params).then(response => {
      })  
    },
    requestPassword (action) {
      if (action == 'doDelete') {
        this.callDoDelete = true
        this.callActivate = false
      } else {
        this.callDoDelete = false
        this.callActivate = true
      }
      globalPassActions.show()
    },
    async doDelete () {
      const params = {
        url: `devices/${this.response.deveui}`,
        method: 'DELETE',
        params: {}
      }
      await request(params).then(response => {
      }) 
    }
  },
  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Devices')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Detail')
    this.$route.meta.pageTitle = this.$t('Path.Detail')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getResponse()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) if (this.callDoDelete) this.doDelete()
      else this.activate()
    }
  }
}
</script>
